import { render, staticRenderFns } from "./after-purchase.vue?vue&type=template&id=4a2573ac&scoped=true&"
import script from "./after-purchase.vue?vue&type=script&lang=js&"
export * from "./after-purchase.vue?vue&type=script&lang=js&"
import style0 from "./after-purchase.vue?vue&type=style&index=0&id=4a2573ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2573ac",
  null
  
)

export default component.exports